import { APIS_BASE_URL } from '../constants/env';

export const getLinkForParselToSetInWallet = (os, shipmentId, parcelId) => {
  const link = `${APIS_BASE_URL}/shipments/${shipmentId}/${os}?parcelId=${parcelId}`;
  return link;
};
